import { useEffect } from 'react'
import { useUser, useClientOptions } from '@paintscout/ui-business'
import { useFlags } from 'shared/components/common/FlagsProvider'
import LogRocketImport from 'logrocket'

import setupLogRocketReact from 'logrocket-react'
import moment from 'moment-timezone'

import * as Sentry from '@sentry/react'

let isInitialized = false

export default function LogRocket(): JSX.Element {
  const { options } = useClientOptions()
  const { user, highestRole } = useUser()
  const { posthogSessionReplay } = useFlags()

  useEffect(() => {
    // Skip LogRocket when PostHog session replay is enabled via LaunchDarkly
    if (posthogSessionReplay) return

    // Never initialize LogRocket for painter accounts — they use PostHog
    if (highestRole === 'painter') return

    if (process.env.LOGROCKET_APP_ID && options?.options?.features?.logRocket?.enabled) {
      const userWhitelist = options.options.features?.logRocket?.userWhitelist ?? []

      const release = `${process.env.VERSION}-${process.env.COMMIT}`

      // if there is no user whitelist or user is included in whitelist
      if (
        userWhitelist.length === 0 ||
        (userWhitelist.length > 0 &&
          (userWhitelist.includes(user.user_id) || userWhitelist.includes(user.user_id.replace('auth0|', ''))))
      ) {
        // we can only run LogRocket.init once
        if (!isInitialized) {
          LogRocketImport.init(process.env.LOGROCKET_APP_ID, {
            release,
            shouldCaptureIP: true
          })
          setupLogRocketReact(LogRocketImport)
          isInitialized = true
        }

        const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
        const standalone = 'standalone' in window.navigator && (window.navigator as any).standalone
        const lastPurge = JSON.parse(window.localStorage.getItem('lastPurge')) ?? 0

        LogRocketImport.identify(user.user_id, {
          name: user.name,
          email: user.email,
          company: options.options.companyName.value,
          companyId: user.app_metadata.companyId,
          iPadOS,
          standalone,
          lastPurge: lastPurge ? moment(lastPurge).tz('America/Edmonton').format('MM/DD/YYYY @ hh:mma') : 'never'
        })

        console.log(release)
        LogRocketImport.info(release)

        LogRocketImport.getSessionURL((sessionURL) => {
          Sentry.getCurrentScope().setExtra('sessionURL', sessionURL)
        })
      }
    }
  }, [options, user.user_id, posthogSessionReplay, highestRole])

  return null
}
